export const EMAIL_SCANNER_EXTENSION = Object.freeze({
  name: "MarkenGroup LeadMagnet E-Mail Scanner",
  currentVersion: "1.3.0",
  storagePath: "admin-tools/email-scanner/markengroup-leadmagnet-email-scanner-1.3.0.zip",
  archiveName: "markengroup-leadmagnet-email-scanner-1.3.0.zip",
  sourceDirectory: "browser-extension",
  maintenanceNote: "Bei jeder Änderung Extension-Version erhöhen, ZIP neu erzeugen, in Firebase Storage ersetzen und den Versionsabgleich aktualisieren."
});
